import type { CustomerTypeAvailabilityType } from '@/lib/cms/cosmic/types/CosmicProductType'
import type { CustomerType } from '@/store/types/user'
import { mapCustomerType } from '@/lib/utils/user/mapCustomerType'

type Props = {
  customerType: CustomerType
  availableFor?: CustomerTypeAvailabilityType
}

export const isAvailableForCustomerType = ({
  customerType,
  availableFor,
}: Props) => {
  // Use shared customer type mapping utility
  const effectiveCustomerType = mapCustomerType(customerType, {
    toLowerCase: true,
  })

  if (!availableFor) return false

  return availableFor[
    effectiveCustomerType as keyof CustomerTypeAvailabilityType
  ]
}
